import { render } from "./GroupIntroduce.vue?vue&type=template&id=35d1b875&scoped=true"
import script from "./GroupIntroduce.vue?vue&type=script&lang=js"
export * from "./GroupIntroduce.vue?vue&type=script&lang=js"

import "./GroupIntroduce.vue?vue&type=style&index=0&id=35d1b875&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d1b875"]])

export default __exports__